import { ITerminology } from "src/library/utils";

export const terminology: ITerminology = {
  drop: {
    singular: {
      text: "drop@@££",
      token: /%DROP%/g
    },
    plural: {
      text: "drops@@££",
      token: /%DROPS%/g
    }
  },
  issue: {
    singular: {
      text: "issue@@££",
      token: /%ISSUE%/g
    },
    plural: {
      text: "issue@@££",
      token: /%ISSUES%/g
    }
  },
  leadtime: {
    singular: {
      text: "lead time@@££",
      token: /%LEAD TIME%/g
    },
    plural: {
      text: "lead times@@££",
      token: /%LEAD TIMES%/g
    }
  },
  customer: {
    singular: {
      text: "customer@@££",
      token: /%CUSTOMER%/g
    },
    plural: {
      text: "customers@@££",
      token: /%CUSTOMERS%/g
    }
  },
  product: {
    singular: {
      text: "product@@££",
      token: /%PRODUCT%/
    },
    plural: {
      text: "products@@££",
      token: /%PRODUCTS%/g
    }
  },
  category: {
    singular: {
      text: "category@@££",
      token: /%CATEGORY%/g
    },
    plural: {
      text: "categories@@££",
      token: /%CATEGORIES%/g
    }
  },
  delivery: {
    singular: {
      text: "delivery@@££",
      token: /%DELIVERY%/g
    },
    plural: {
      text: "deliveries@@££",
      token: /%DELIVERIES%/g
    }
  },
  notification: {
    singular: {
      text: "notification@@££",
      token: /%NOTIFICATION%/g
    },
    plural: {
      text: "notifications@@££",
      token: /%NOTIFICATIONS%/g
    }
  },
  user: {
    singular: {
      text: "user@@££",
      token: /%USER%/g
    },
    plural: {
      text: "users@@££",
      token: /%USERS%/g
    }
  },
  adhoc: {
    singular: {
      text: "ad hoc@@££",
      token: /%ADHOC%/g
    },
    plural: {
      text: "ad hoc@@££",
      token: /%ADHOCS%/g
    }
  },
  order: {
    singular: {
      text: "order@@££",
      token: /%ORDER%/g
    },
    plural: {
      text: "orders@@££",
      token: /%ORDERS%/g
    }
  },
  list: {
    singular: {
      text: "list@@££",
      token: /%LIST%/g
    },
    plural: {
      text: "lists@@££",
      token: /%LISTS%/g
    }
  },
  schedule: {
    singular: {
      text: "standing order@@££",
      token: /%SCHEDULE%/g
    },
    plural: {
      text: "standing orders@@££",
      token: /%SCHEDULE%/g
    }
  },
  cutOff: {
    singular: {
      text: "cut off@@££",
      token: /%CUTOFF%/g
    },
    plural: {
      text: "cut offs@@££",
      token: /%CUTOFF%/g
    }
  },
  shelfLife: {
    singular: {
      text: "shelf life@@££",
      token: /%SHELF LIFE%/g
    },
    plural: {
      text: "shelf lifes@@££",
      token: /%SHELF LIFE%/g
    }
  },
  cart: {
    singular: {
      text: "cart@££",
      token: /%CART%/g
    },
    plural: {
      text: "carts@@££",
      token: /%CART%/g
    }
  },
  partNumber: {
    singular: {
      text: "part number@££",
      token: /%PART NUMBER%/g
    },
    plural: {
      text: "part numbers@@££",
      token: /%PART NUMBERS%/g
    }
  },
  fulfilment: {
    singular: {
      text: "fulfilment@££",
      token: /%fulfilment%/g
    },
    plural: {
      text: "fulfilment@@££",
      token: /%fulfilment%/g
    }
  },
  callOff: {
    singular: {
      text: "Call-Off",
      token: /%CALL-OFF%/g
    },
    plural: {
      text: "Call-Offs",
      token: /%CALL-OFFS%/g
    }
  },
  orderVariant: {
    singular: {
      text: "Order Variant",
      token: /%ORDER-VARIANT%/g
    },
    plural: {
      text: "Order Variants",
      token: /%ORDER-VARIANTS%/g
    }
  }
};
